// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","1164":"600088bd","1618":"761dbcce","5122":"1f3a2121"}[chunkId] + ".css";
};